import type { IconProps } from '../types/IconProps.ts';
export const Link: IconProps = {
    name: 'Link',
    children: [
        `<path d="M12.7 4.22a5 5 0 0 1 7.08 7.07l-2.83 2.83a5 5 0 0 1-7.07 0" />`,
        `<path d="M11.3 19.78a5 5 0 1 1-7.08-7.07l2.83-2.83a5 5 0 0 1 7.07 0" />`,
    ]
};